// src/routes/AppRoutes.jsx

import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "../components/Layout/AppLayout";
import PrivateRoute from "../routes/PrivateRoute";

// ⭐️ GANTI SEMUA IMPORT STATIS MENJADI DYNAMIC IMPORT (React.lazy)
// Halaman Master
const SatuanPage = lazy(() => import("../pages/master/SatuanPage"));
const KodepersediaanPage = lazy(
  () => import("../pages/master/KodepersediaanPage"),
);
const BarangPage = lazy(() => import("../pages/master/BarangPage"));
const MsUserPage = lazy(() => import("../pages/master/MsUserPage"));
const ProkegPage = lazy(() => import("../pages/master/ProkegPage"));
const RekeningPage = lazy(() => import("../pages/master/RekeningPage"));
const SupplierPage = lazy(() => import("../pages/master/SupplierPage"));

// HALAMAN PENGADAAN
const PengadaanInputPage = lazy(
  () => import("../pages/pengadaan/PengadaanInputPage"),
);
const PengadaanInputNonPage = lazy(
  () => import("../pages/pengadaan/PengadaanInputNonPage"),
);
const PengadaanListPage = lazy(
  () => import("../pages/pengadaan/PengadaanListPage"),
);
const PengadaanLisNonPage = lazy(
  () => import("../pages/pengadaan/PengadaanListNonPage"),
);

const PengadaanUpdatePage = lazy(
  () => import("../pages/pengadaan/PengadaanUpdatePage"),
);
const PengadaanUpdateNonPage = lazy(
  () => import("../pages/pengadaan/PengadaanUpdateNonPage"),
);
const DashPengadaanPage = lazy(
  () => import("../pages/pengadaan/DashPengadaanPage"),
);
const PengadaanValidPage = lazy(
  () => import("../pages/pengadaan/PengadaanValidPage"),
);
const PengadaanListSahPage = lazy(
  () => import("../pages/pengadaan/PengadaanListSahPage"),
);
const PengadaanValidUpdatePage = lazy(
  () => import("../pages/pengadaan/PengadaanValidUpdatePage"),
);

// Halaman Transaksi
// PENERIMAAN
const PemeriksaanUpdatePage = lazy(
  () => import("../pages/penerimaan/PemeriksaanUpdatePage"),
);
const PenerimaanInputPage = lazy(
  () => import("../pages/penerimaan/PenerimaanInputPage"),
);
const PemeriksaanListPage = lazy(
  () => import("../pages/penerimaan/PemeriksaanListPage"),
);
const PenerimaanListPage = lazy(
  () => import("../pages/penerimaan/PenerimaanListPage"),
);
const PenerimaanUpdatePage = lazy(
  () => import("../pages/penerimaan/PenerimaanUpdatePage"),
);

// PENGELUARAN
const PengeluaranInputPage = lazy(
  () => import("../pages/pengeluaran/PengeluaranInputPage"),
);
const PengeluaranListPage = lazy(
  () => import("../pages/pengeluaran/PengeluaranListPage"),
);
const PengeluaranUpdatePage = lazy(
  () => import("../pages/pengeluaran/PengeluaranUpdatePage"),
);

// LAINNYA
// const PenerimaanHPage = lazy(() =>
//   import("../pages/transaksi/PenerimaanHPage")
// );

const PenerimaanEditModal = lazy(
  () => import("../pages/transaksi/PenerimaanEditModal"),
);
// const ModalEditDetail = lazy(() =>
//   import("../pages/transaksi/ModalEditDetail")
// );
// const PenerimaanEditPage = lazy(() =>
//   import("../pages/transaksi/PenerimaanEditPage")
// );
// const PenerimaanDetailPage = lazy(() =>
//   import("../pages/penerimaan/PenerimaanDetailPage")
// );

const MutasiInputPage = lazy(
  () => import("../pages/transaksi/MutasiInputPage"),
);
const ReturBarangPage = lazy(
  () => import("../pages/transaksi/ReturBarangPage"),
);
const PenyesuaianStokPage = lazy(
  () => import("../pages/transaksi/PenyesuaianStokPage"),
);

// Laporan
const LaporanPengadaanPage = lazy(
  () => import("../pages/pengadaan/LaporanPengadaan/LaporanPengadaanPage"),
);
const RegisterPengadaanPage = lazy(
  () => import("../pages/pengadaan/LaporanPengadaan/RegisterPengadaanPage"),
);
const RegisterBapPage = lazy(
  () => import("../pages/pengadaan/LaporanPengadaan/RegisterBapPage"),
);
const LaporanBapPage = lazy(
  () => import("../pages/pengadaan/LaporanBap/LaporanBapPage"),
);

const LaporanStokPage = lazy(
  () => import("../pages/laporan/jumlahStok/LaporanStokPage"),
);
const LaporanKartuPage = lazy(
  () => import("../pages/laporan/kartuBarang/LaporanKartuPage"),
);

const LaporanPenerimaanPage = lazy(
  () => import("../pages/laporan/penerimaanBarang/LaporanPenerimaanPage"),
);
const LaporanSoPage = lazy(
  () => import("../pages/laporan/stockOpname/LaporanSoPage"),
);
// Stock Opname
const JadwalSoPage = lazy(() => import("../pages/stockopname/JadwalSoPage"));
const SoWizardPage = lazy(() => import("../pages/stockopname/SoWizardPage"));

//Penerimaan & Pengeluaran Wizard
// const PenerimaanWizardPage = lazy(() =>
//   import("../pages/transaksi/PenerimaanWizardPage")
// );
// const PengeluaranWizardPage = lazy(() =>
//   import("../pages/transaksi/PengeluaranWizardPage")
// );

// Pengaturan
const ManajemenAksesPage = lazy(
  () => import("../pages/pengaturan/ManajemenAksesPage"),
);
const RoleMenuPage = lazy(() => import("../pages/pengaturan/RoleMenuPage"));
const UserProfilePage = lazy(
  () => import("../pages/pengaturan/UserProfilePage"),
);

// Auth & Dashboard
const LoginPage = lazy(() => import("../pages/LoginPage"));
const RegisterPage = lazy(() => import("../pages/RegisterPage"));
const DashboardPage = lazy(() => import("../pages/DashboardPage"));

// ⭐️ Komponen Loading Fallback
const LoadingFallback = () => (
  <div className="flex justify-center items-center h-screen">
    <span className="loading loading-spinner loading-lg text-primary"></span>
    <p className="ml-2 text-gray-500">Memuat halaman...</p>
  </div>
);

// ⭐️ Komponen Wrapper untuk Suspense (Solusi agar Toaster tidak terganggu)
const SuspendedElement = ({ Component }) => (
  <Suspense fallback={<LoadingFallback />}>
    <Component />
  </Suspense>
);

const AppRoutes = () => (
  <Routes>
    {/* Public Routes (Gunakan Suspense untuk lazy load) */}
    <Route path="/login" element={<SuspendedElement Component={LoginPage} />} />
    <Route
      path="/register"
      element={<SuspendedElement Component={RegisterPage} />}
    />

    {/* Private Routes */}
    <Route
      path="/*"
      element={
        <PrivateRoute>
          {/* 🛑 HAPUS SUSPENSE di sini, biarkan AppLayout stabil */}
          <AppLayout />
        </PrivateRoute>
      }
    >
      {/* Semua rute di dalam AppLayout sekarang menggunakan SuspendedElement */}
      {/* Dashboard */}
      <Route index element={<SuspendedElement Component={DashboardPage} />} />

      {/* Master */}
      <Route
        path="master/satuan"
        element={<SuspendedElement Component={SatuanPage} />}
      />
      <Route
        path="master/pegawai"
        element={<SuspendedElement Component={MsUserPage} />}
      />
      <Route
        path="master/prokeg"
        element={<SuspendedElement Component={ProkegPage} />}
      />
      <Route
        path="master/rekening"
        element={<SuspendedElement Component={RekeningPage} />}
      />
      <Route
        path="master/supplier"
        element={<SuspendedElement Component={SupplierPage} />}
      />
      <Route
        path="master/persediaan"
        element={<SuspendedElement Component={KodepersediaanPage} />}
      />
      <Route
        // path="master/daftar-barang"
        path="master/barang"
        element={<SuspendedElement Component={BarangPage} />}
      />

      {/* UPBJ */}
      <Route
        path="pengadaan/input"
        element={<SuspendedElement Component={PengadaanInputPage} />}
      />
      <Route
        path="pengadaan/inputnon"
        element={<SuspendedElement Component={PengadaanInputNonPage} />}
      />
      <Route
        path="pengadaan/list"
        element={<SuspendedElement Component={PengadaanListPage} />}
      />
      <Route
        path="pengadaan/listnon"
        element={<SuspendedElement Component={PengadaanLisNonPage} />}
      />
      <Route
        path="pengadaan/dash"
        element={<SuspendedElement Component={DashPengadaanPage} />}
      />
      <Route
        path="pengadaan/pengadaan-update"
        element={<SuspendedElement Component={PengadaanUpdatePage} />} // TARGET FIX
      />
      <Route
        path="pengadaan/spkupnon"
        element={<SuspendedElement Component={PengadaanUpdateNonPage} />} // TARGET FIX
      />

      {/* BAP*/}
      <Route
        path="pengadaan/baplist"
        element={<SuspendedElement Component={PengadaanValidPage} />}
      />
      <Route
        path="pengadaan/baplistsah"
        element={<SuspendedElement Component={PengadaanListSahPage} />}
      />
      <Route
        path="pengadaan/bap"
        element={<SuspendedElement Component={PengadaanValidUpdatePage} />} // TARGET FIX
      />

      {/* Transaksi Penerimaan*/}
      <Route
        path="transaksi/pemeriksaan-update"
        element={<SuspendedElement Component={PemeriksaanUpdatePage} />} // TARGET FIX
      />
      <Route
        path="transaksi/penerimaan-input"
        element={<SuspendedElement Component={PenerimaanInputPage} />}
      />
      <Route
        path="transaksi/pemeriksaan-list"
        element={<SuspendedElement Component={PemeriksaanListPage} />}
      />
      <Route
        path="transaksi/penerimaan-list"
        element={<SuspendedElement Component={PenerimaanListPage} />}
      />
      <Route
        path="transaksi/penerimaan-update"
        element={<SuspendedElement Component={PenerimaanUpdatePage} />} // TARGET FIX
      />

      {/* Transaksi Pengeluaran*/}
      <Route
        path="transaksi/pengeluaran-input"
        element={<SuspendedElement Component={PengeluaranInputPage} />}
      />
      <Route
        path="transaksi/pengeluaran-list"
        element={<SuspendedElement Component={PengeluaranListPage} />}
      />
      <Route
        path="transaksi/pengeluaran-update"
        element={<SuspendedElement Component={PengeluaranUpdatePage} />}
      />

      {/* Transaksi Lainnya*/}
      {/* <Route
        path="transaksi/penerimaan"
        element={<SuspendedElement Component={PenerimaanHPage} />}
      /> */}

      <Route
        path="transaksi/penerimaan-edit/:id"
        element={<SuspendedElement Component={PenerimaanEditModal} />}
      />
      {/* <Route
        path="transaksi/penerimaan-editdetail/:id"
        element={<SuspendedElement Component={ModalEditDetail} />}
      /> */}
      {/* <Route
        path="transaksi/penerimaan-detail/:id"
        element={<SuspendedElement Component={PenerimaanDetailPage} />}
      /> */}
      {/* <Route
        path="transaksi/penerimaan/edit-old/:id"
        element={<SuspendedElement Component={PenerimaanEditPage} />}
      /> */}

      <Route
        path="transaksi/mutasi-input"
        element={<SuspendedElement Component={MutasiInputPage} />}
      />
      <Route
        path="transaksi/retur"
        element={<SuspendedElement Component={ReturBarangPage} />}
      />
      <Route
        path="transaksi/penyesuaian"
        element={<SuspendedElement Component={PenyesuaianStokPage} />}
      />

      {/* Laporan */}
      <Route
        path="laporan/pengadaan"
        element={<SuspendedElement Component={LaporanPengadaanPage} />}
      />
      <Route
        path="reg/spk"
        element={<SuspendedElement Component={RegisterPengadaanPage} />}
      />
      <Route
        path="reg/bap"
        element={<SuspendedElement Component={RegisterBapPage} />}
      />
      <Route
        path="laporan/Bap"
        element={<SuspendedElement Component={LaporanBapPage} />}
      />

      <Route
        path="laporan/stok"
        element={<SuspendedElement Component={LaporanStokPage} />}
      />
      <Route
        path="laporan/kartu"
        element={<SuspendedElement Component={LaporanKartuPage} />}
      />

      <Route
        path="laporan/penerimaan-buku"
        element={<SuspendedElement Component={LaporanPenerimaanPage} />}
      />
      <Route
        path="laporan/stok-opname"
        element={<SuspendedElement Component={LaporanSoPage} />}
      />

      {/* Stock Opname */}
      <Route
        path="stockopname/wizard"
        element={<SuspendedElement Component={SoWizardPage} />}
      />
      <Route
        path="stockopname/jadwalso"
        element={<SuspendedElement Component={JadwalSoPage} />}
      />

      {/* Penerimaan */}
      {/* <Route
        path="transaksi/wizard"
        element={<SuspendedElement Component={PenerimaanWizardPage} />}
      /> */}
      {/* Pengeluaran */}
      {/* <Route
        path="transaksi/wizard-out"
        element={<SuspendedElement Component={PengeluaranWizardPage} />}
      /> */}

      {/* Pengaturan */}
      <Route
        path="pengaturan/role-menu"
        element={<SuspendedElement Component={RoleMenuPage} />}
      />
      <Route
        path="pengaturan/manajemen-akses"
        element={<SuspendedElement Component={ManajemenAksesPage} />}
      />
      <Route
        path="pengaturan/profil"
        element={<SuspendedElement Component={UserProfilePage} />}
      />
    </Route>
  </Routes>
);

export default AppRoutes;
